export const ERROR_TYPE = { generic: 1, network: 2, server: 3 };
